import { render, staticRenderFns } from "./fab_button.vue?vue&type=template&id=36cf7596&"
import script from "./fab_button.vue?vue&type=script&lang=js&"
export * from "./fab_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports